import Box from "@/components/Box";
import Image from "@/components/Image";
import Stack from "@/components/Stack";
import { theme } from "@/core/theme";
import ChevronComponent from "@/tpo/Chevron";
import copyTextToClipboard from "@/utils/copyTextToClipboard";
import ButtonV2 from "@/v2/Buttons";

function PhlebotomyPartner({ name, children, image, link }) {
  return (
    <Box
      bg="white"
      width={"100%"}
      borderRadius={5}
      px={[20, 20, 40]}
      pt={theme.spacing.medium}
      pb={theme.spacing.medium}
    >
      <Stack itemBoxProps={{ pb: "10px", pt: "10px" }}>
        <Image src={image} alt={name} width={200} height={200} />
        <Box fontFamily="gilroyMedium" fontSize={16}>
          {children}
        </Box>
        <Box display="flex" flexDirection={["column", "row"]} gap={20}>
          <ButtonV2
            color="dark"
            rightIcon={<ChevronComponent />}
            onClick={() => window.open(link, "_blank")}
          >
            Book now
          </ButtonV2>
          <ButtonV2 color="dark" onClick={() => copyTextToClipboard(link)}>
            Copy link
          </ButtonV2>
        </Box>
      </Stack>
    </Box>
  );
}

function PhlebotomySection() {
  return (
    <>
      <Box fontFamily="gilroyBold" fontSize={28} as="h2">
        Phlebotomy
      </Box>
      <Box
        fontFamily="gilroyMedium"
        fontSize={16}
        pt={theme.spacing.medium}
        pb={theme.spacing.medium}
      >
        Does your test require a blood draw? We&apos;ve partnered with trusted phlebotomy networks
        to support your sample collection. When choosing from the options below, please check
        whether you need paediatric services or if your sample requires centrifugation.
      </Box>
      <Box
        display="flex"
        gap={20}
        alignItems="flex-start"
        flexDirection={["column", "column", "row"]}
      >
        <PhlebotomyPartner
          name="Tuli"
          image="/phlebotomy-tuli.png"
          link="https://portal.tuli.health/#/clinic/pharmas?clinicid=96"
        >
          <p>
            Access blood draw services at local pharmacies via the nationwide phlebotomy service.
          </p>
          <br />
          <p>You can book directly or share a link for easy access.</p>
          <br />
          <p>This partner does not offer centrifugation or paediatric blood draw services.</p>
        </PhlebotomyPartner>
        <PhlebotomyPartner
          name="Bloods & Beyond"
          image="/phlebotomy-bloods-beyond.png"
          link="https://finder.bloodsandbeyond.co.uk/finder/inline/01k18kfvq0zbwan6jtcvvfq1d2"
        >
          <p>Our mobile phlebotomy services bring blood collection right to your home, ensuring</p>
          <br />
          <p>
            convenience for your patients. You can book directly or share a link for easy access.
          </p>
          <br />
          <p>Use this service for Centrifuge & paediatric options.</p>
        </PhlebotomyPartner>
      </Box>
    </>
  );
}

export default function OrganisationOrderConfirmationBox({ requiresPhlebotomy = false }) {
  return (
    <Box px={[20, 20, "8vw"]}>
      <Box
        fontSize={[32, 32, 44]}
        lineHeight={["130%", "115%", "115%"]}
        fontFamily="gilroyBold"
        as="h1"
        mb={theme.spacing.medium}
      >
        Order Confirmation
      </Box>
      <Box fontFamily="gilroyMedium" fontSize={16} pb={theme.spacing.medium}>
        Thank you for your order! Your purchase has been successfully placed, and we&apos;re now
        preparing everything for you. You&apos;ll find the details of your order below
      </Box>
      {requiresPhlebotomy && <PhlebotomySection />}
    </Box>
  );
}
